module.exports = __webpack_public_path__ + "static/bagel-cba5261217e42fb50959cc06dd9ab80c.png";